<div class="buttons-container">
  <div class="type-btn-container">
    <div class="animation-container" [class.open]="mapTypeSelectionPopupVisible()">
      <div class="selection-container" *ngIf="mapTypeSelectionPopupVisible()">
        <button class="hybrid-button" (click)="setHybridType($event)" [title]="hybridLabel | translate" [class.active]="activeMapType() === mapTypeEnum.Hybrid">
          {{hybridLabel | translate}}
        </button>
        <div class="spacer"></div>
        <button class="roadmap-button" (click)="setRoadmapType($event)" [title]="roadmapLabel | translate" [class.active]="activeMapType() === mapTypeEnum.Roadmap">
          {{roadmapLabel | translate}}
        </button>
      </div>
    </div>
    <div class="center-button-container">
      <button class="main-button" (click)="toggleMapTypeSelectionPopup($event)" [title]="mapTypeLabel | translate">
        <qpoint-icon [icon]="'map'"  [iconType]="'regular'" ></qpoint-icon>
      </button>
      <div class="vertical-button-backdrop" [style.height.px]="getBackDropHeight()"></div>
      <div *ngIf="lastSpacerExists()" class="spacer-horizontal"></div>
    </div>
  </div>
</div>
